<template>
  <span>
    <span v-for="(service, index) in services" :key="service">
      <router-link :to="service">{{service}}</router-link><span v-if="index + 2 < services.length">, </span><span v-if="index === services.length - 2"> and </span>
    </span>
  </span>
</template>
<script>
export default {
  name: 'ServicesList',
  data () {
    return {
      services: Object.keys(this.$store.getters.icons)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/services-list.vue